import { useCallback, useContext } from 'react';
import { useReactFlow } from 'reactflow';

import { StateContext } from '@/Pages/Graph/src/control/state';
import { StudioFeatureFlagsContext } from '@/Pages/Graph/src/hooks/useStudioFeatureFlagsContext';

import { useGraphStore } from '../store';

export const useToggleSubgraphExpansion = () => {
  const { showGraphZoomControls } = useContext(StudioFeatureFlagsContext);
  const { subgraphSelection, toggleSubgraphSelection } =
    useContext(StateContext);
  const setNodePositions = useGraphStore((state) => state.setNodePositions);
  const nodePositions = useGraphStore((state) => state.nodePositions);

  const fitToViewMode = useGraphStore((state) => state.fitToViewMode);
  const setNeedsFitting = useGraphStore((state) => state.setNeedsFitting);
  const { getNodes } = useReactFlow();
  return useCallback(
    (nodeId: string) => {
      const nodes = getNodes();
      const node = nodes.find((node) => node.id === nodeId);
      if (!node) return;
      if (!subgraphSelection.includes(node.id) && showGraphZoomControls) {
        // save node position when expanding subgraph
        setNodePositions({
          ...nodePositions,
          [node.id]: {
            x: node.position.x,
            y: node.position.y,
            // if node has been manually dragged, keep it fixed
            isFixed: nodePositions[node.id]?.isFixed ?? false,
          },
        });
      } else {
        // if node has not been manually dragged, reset its position
        if (!nodePositions[node.id]?.isFixed) {
          setNodePositions({
            ...nodePositions,
            [node.id]: {
              x: 0,
              y: 0,
              isFixed: false,
            },
          });
        }
      }
      toggleSubgraphSelection(node.id);
      if (fitToViewMode) {
        setNeedsFitting(true);
      }
    },
    [
      showGraphZoomControls,
      setNodePositions,
      nodePositions,
      subgraphSelection,
      toggleSubgraphSelection,
      fitToViewMode,
      setNeedsFitting,
      getNodes,
    ]
  );
};
